import * as _ from "lodash";

import {Pipe, PipeTransform} from "@angular/core";

	@Pipe({
	    name: "dataFilter"
	})
	export class DataFilterPipe implements PipeTransform {
		transform(items: any, filter: any, isAnd: boolean): any {
		  if (filter && Object.keys(filter).length > 0 && Array.isArray(items)) {
			let filterKeys = Object.keys(filter);
			if (isAnd) {
			  return items.filter(item =>
				filterKeys.reduce((memo, keyName) =>
				  memo && (filter[keyName] === "" || this.isValidFilterValue(filter[keyName]) && new RegExp(filter[keyName], 'gi').test(item[keyName]))
				, true)
			  );
			} else {
			  return items.filter(item =>
				filterKeys.some((keyName) =>
				  filter[keyName] === "" || this.isValidFilterValue(filter[keyName]) && new RegExp(filter[keyName], 'gi').test(item[keyName]))
			  );
			}
		  } else {
			return items;
		  }
		}
	  
		private isValidFilterValue(value: string): boolean {
		  const invalidCharacters = /[\(\*\)]/;
		  return !invalidCharacters.test(value);
		}
	  }
	  
// export class DataFilterPipe implements PipeTransform {

// 	transform(items: any, filter: any, isAnd: boolean): any {

// 	if (filter && Array.isArray(items)) {

// 	  let filterKeys = Object.keys(filter);

// 	  if (isAnd) {

// 		return items.filter(item =>

// 			filterKeys.reduce((memo, keyName) =>

// 				(memo && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === "", true));

					

// 	  } else {

// 		return items.filter(item => {

// 		  return filterKeys.some((keyName) => {

// 			return new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === "";

// 		  });

// 		});

// 	  }

// 	} else {

// 	  return items;

// 	}

// 	}



    

// }






// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/data-filter.pipe.ts